import createTransactionsAPI from "@/helpers/rtk_transactions_resource_factory";
import { getCurrentUser } from "@/helpers/session_helper";

const baseURL = process.env.REACT_APP_GLOBO_API + '/transactions/doctorEnrollments';
const type = "DoctorEnrollments";
const currentUser = getCurrentUser()

export const doctorEnrollmentsAPI = createTransactionsAPI({
  baseURL: baseURL,
  resource: "DoctorEnrollments",
  tagTypes: ["DoctorEnrollments"],
  idKey: "doctorEnrollmentId",
  lookupMap: ({ doctorEnrollmentId, referenceNo }) => ({
    value: doctorEnrollmentId,
    label: referenceNo
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListDoctorEnrollmentsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      }
    }),

    getFilesDoctorEnrollments: query(`${baseURL}/files/list`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) =>
        result?.success
          ? [...(result?.items || result?.returnData)?.map((item) => ({ type: type, id: item[idKey] })), { type: type, id: type }]
          : [{ type: type, id: type }],
    }),
  }),
  customMutations: (mutation, mutationOptions,builder) => ({
    submitDoctorEnrollments: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnDoctorEnrollments: mutation(`${baseURL}/return`, mutationOptions("save")),
    approveDoctorEnrollments: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectDoctorEnrollments: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelDoctorEnrollments: mutation(`${baseURL}/cancel`, mutationOptions("save")),
    filesUploadDoctorEnrollments: mutation(`${baseURL}/files/upload`),
    filesDeleteDoctorEnrollments: mutation(`${baseURL}/files/delete`),

     exportListForViewerDoctorErollments: builder.mutation({
      query: (params) => ({
        url: `${baseURL}/exportListForViewer`,
        method: "POST",
        body: params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentUser?.token}`,
        },
      }),
      async onQueryStarted(params, { queryFulfilled }) {
        try {
          const response = await fetch(`${baseURL}/exportListForViewer`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${currentUser?.token}`,
            },
            body: JSON.stringify(params),
          });

          if (!response.ok) throw new Error("Export failed");

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `DoctorEnrollments-Viewer-${new Date().toISOString().split("T")[0]}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          await queryFulfilled.catch(() => { });
        } catch (err) {
          console.error("Export failed:", err);
          throw err;
        }
      },
    }),

  }),
});

export const {
  useGetDoctorEnrollmentsQuery,
  useGetListDoctorEnrollmentsForViewersQuery,
  useExportDoctorEnrollmentsMutation,
  useFindDoctorEnrollmentsQuery,
  useLookUpDoctorEnrollmentsMutation,
  useSaveDoctorEnrollmentsMutation,
  useSubmitDoctorEnrollmentsMutation,
  useReturnDoctorEnrollmentsMutation,
  useApproveDoctorEnrollmentsMutation,
  useRejectDoctorEnrollmentsMutation,
  useCancelDoctorEnrollmentsMutation,
  useDeleteDoctorEnrollmentsMutation,
  useFilesUploadDoctorEnrollmentsMutation,
  useFilesDeleteDoctorEnrollmentsMutation,
  useGetFilesDoctorEnrollmentsQuery,
  useExportListForViewerDoctorErollmentsMutation
} = doctorEnrollmentsAPI;
